const showTurnstileError = function(form, message) {
    const errorContainer = form.querySelector('.turnstile-search-error');
    if (errorContainer) errorContainer.textContent = message;
};

const clearTurnstileAutoSubmitInterval = function(form) {
    if (form.turnstileAutoSubmitInterval) {
        window.clearInterval(form.turnstileAutoSubmitInterval);
        form.turnstileAutoSubmitInterval = null;
    }
};

const renderTurnstileWidget = function(form) {
    const widgetContainer = form.querySelector('[data-turnstile-widget="true"]');
    if (!widgetContainer || form.dataset.turnstileWidgetRendered === 'true') return false;
    if (!window.turnstile || typeof window.turnstile.render !== 'function') return false;

    const sitekey = widgetContainer.dataset.sitekey;
    if (!sitekey) return false;

    window.turnstile.render(widgetContainer, {
        sitekey: sitekey,
        callback: window.turnstileSearchAutoSubmit
    });

    form.dataset.turnstileWidgetRendered = 'true';
    return true;
};

const verifyTurnstileProtectedForm = async function(form, csrfToken, tokenOverride) {
    if (!form || form.dataset.turnstileSubmitting === 'true') return false;

    const responseField = form.querySelector('input[name="cf-turnstile-response"]');
    const token = tokenOverride || responseField?.value;
    if (!token) {
        showTurnstileError(form, 'Please complete the security check.');
        return false;
    }

    clearTurnstileAutoSubmitInterval(form);
    form.dataset.turnstileSubmitting = 'true';
    showTurnstileError(form, '');

    const submitButtons = form.querySelectorAll('button[type="submit"], input[type="submit"]');
    submitButtons.forEach((button) => {
        button.disabled = true;
    });

    try {
        const response = await fetch(form.dataset.turnstileVerifyPath, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': csrfToken,
                'Accept': 'application/json'
            },
            body: JSON.stringify({ response: token })
        });

        if (!response.ok) {
            const body = await response.json().catch(() => ({}));
            showTurnstileError(form, body.error || 'Please refresh the page and try the security check again.');
            return false;
        }

        if (form.dataset.turnstileRedirectTo) {
            window.location.assign(form.dataset.turnstileRedirectTo);
        }

        return true;
    } catch (_error) {
        showTurnstileError(form, 'Please refresh the page and try the security check again.');
        return false;
    } finally {
        form.dataset.turnstileSubmitting = 'false';

        submitButtons.forEach((button) => {
            button.disabled = false;
        });
    }
};

window.turnstileSearchAutoSubmit = function(token) {
    const form = document.querySelector('form[data-turnstile-protected="true"]');
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
    if (!form) return;

    void verifyTurnstileProtectedForm(form, csrfToken, token);
};

export const setupTurnstileProtectedForms = function() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

    document.querySelectorAll('form[data-turnstile-protected="true"]').forEach(function(form) {
        if (form.dataset.turnstileInitialized === 'true') return;

        form.dataset.turnstileInitialized = 'true';

        renderTurnstileWidget(form);

        if (form.dataset.turnstileRedirectTo) {
            form.turnstileAutoSubmitInterval = window.setInterval(function() {
                const responseField = form.querySelector('input[name="cf-turnstile-response"]');
                if (responseField?.value) {
                    void verifyTurnstileProtectedForm(form, csrfToken);
                }
            }, 500);
        }

        form.addEventListener('submit', async function(event) {
            event.preventDefault();
            await verifyTurnstileProtectedForm(form, csrfToken);
        });
    });
};
